import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import EditorContentStateQuery, {
	type EditorContentStateQuery$data,
	type EditorContentStateQuery$variables,
} from './__generated__/EditorContentStateQuery.graphql.ts';

type PreloadEditorContentStateParams = {
	contentId: any;
	useCache: boolean;
	shouldGetDraftVersion: boolean;
};

export function preloadEditorContentState({
	contentId,
	useCache,
	shouldGetDraftVersion,
}: PreloadEditorContentStateParams) {
	return query<EditorContentStateQuery$data, EditorContentStateQuery$variables>({
		query: EditorContentStateQuery,
		variables: {
			contentId,
			isDraft: shouldGetDraftVersion,
		},
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	});
}
